<template>
  <div class="captcha-box">
    <img
      v-if="image"
      :src="image"
      alt="Captcha"
      class="captcha-img"
      title="Klik untuk ganti kode"
      @click="refresh()"
    />
    <div v-else class="captcha-img captcha-placeholder" @click="refresh()">
      Memuat captcha...
    </div>

    <div class="d-flex align-items-center mt-2">
      <input
        ref="input"
        type="text"
        class="form-control captcha-input"
        placeholder="Kode captcha"
        maxlength="5"
        autocomplete="off"
        :value="value"
        @input="$emit('input', $event.target.value.toUpperCase())"
      />
      <button
        type="button"
        class="captcha-restart-button btn btn-outline-secondary btn-sm"
        title="Ganti kode"
        @click="refresh(true)"
      >
        <i class="bi bi-arrow-clockwise"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaptchaInput",
  props: {
    value: { type: String, default: "" },
    token: { type: String, default: "" },
    url: { type: String, required: true },
  },
  data() {
    return { image: "" };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      try {
        const res = await fetch(`${this.url}?t=${Date.now()}`, { cache: "no-store" });
        const data = await res.json();
        this.image = data.image || "";
        this.$emit("update:token", data.token || "");
      } catch (e) {
        this.image = "";
        this.$emit("update:token", "");
        console.error("Gagal memuat captcha:", e);
      }
    },
    refresh(focus = false) {
      this.$emit("input", "");
      this.load();
      if (focus) {
        this.$nextTick(() => {
          if (this.$refs.input) this.$refs.input.focus();
        });
      }
    },
  },
};
</script>

<style scoped>
.captcha-box {
  width: 224px;
  --captcha-h: 44px;
}
.captcha-img {
  display: block;
  width: 100%;
  min-height: 72px;
  border: 2px solid #b2c2d3;
  border-radius: 6px;
  cursor: pointer;
  background: #f5f7fa;
}
.captcha-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #718096;
  font-size: 14px;
}
.captcha-input {
  flex: 1;
  min-width: 0;
  height: var(--captcha-h);
  border: 2px solid #b2c2d3;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.captcha-restart-button {
  flex-shrink: 0;
  width: var(--captcha-h);
  height: var(--captcha-h);
  margin-left: 8px;
  padding: 0;
  border: 2px solid #b2c2d3;
  border-radius: 6px !important;
  background: #f5f7fa;
  color: #0f2f5f;
}
</style>